import { toSignal } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ControlContainer, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { afterRenderEffect, Component, computed, inject, Injector, Signal, signal, untracked } from "@angular/core";

import { customValidations, Dropdown, LookupsService, fallbackOnError } from "src/app/core";
import { InputTextComponent, DropdownComponent, InputTextDropdownComponent } from "src/app/shared";

const SHARED = [InputTextComponent, DropdownComponent, InputTextDropdownComponent];

@Component({
  selector: "app-company-details",
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED],
  templateUrl: "./company-details.component.html",
  styleUrl: "./company-details.component.scss",
})
export class CompanyDetailsComponent {
  private injector = inject(Injector);
  private lookupsService = inject(LookupsService);
  private activatedRoute = inject(ActivatedRoute);
  private controlContainer = inject(ControlContainer);

  itemId = this.activatedRoute.snapshot.paramMap.get("id");
  countries = toSignal(this.lookupsService.getCountries().pipe(fallbackOnError([])), { initialValue: [] });
  governorates: Signal<Dropdown[] | undefined> = signal([]);
  states: Signal<Dropdown[] | undefined> = signal([]);

  currentPhoneCountryCode = computed(() => {
    return "+968";

    // const countryCode = window.navigator.language.split("-").pop();
    // const country = this.countries().find((c) => c.code === countryCode);

    // if (!country) return null;
    // return country.phoneCode as string;
  });

  get form() {
    return this.controlContainer.control as FormGroup;
  }

  get phoneCountryCode() {
    if (!this.countries().length && !this.form.get("membershipCompanyDetails")?.get("countryCode")?.value) return null;

    const country = this.countries().find((c) => c.phoneCode === this.form.get("membershipCompanyDetails")?.get("countryCode")?.value);

    if (!country) return null;
    return country.code;
  }

  constructor() {
    afterRenderEffect(() => {
      if (this.countries().length && !this.form.get("membershipCompanyDetails")?.get("countryCode")?.value) {
        this.form.get("membershipCompanyDetails")?.get("countryCode")?.setValue(this.currentPhoneCountryCode());
        this.getPhoneCountryCode(this.currentPhoneCountryCode()!);
      }

      if (this.countries().length) {
        const isOman = this.countries()
          .find((n) => n.id === this.form.get("membershipCompanyDetails")?.get("countryId")?.value)
          ?.code.toLowerCase()
          .includes("om");

        if (this.itemId && isOman) {
          untracked(() => {
            this.getGovernorates(this.form.get("membershipCompanyDetails")?.get("countryId")?.value!);
            this.getStates(this.form.get("membershipCompanyDetails")?.get("governorateId")?.value!);
          });
        }
      }
    });
  }

  getGovernorates(id: number) {
    const isOman = this.countries()
      .find((n) => n.id === id)
      ?.code.toLowerCase()
      .includes("om");

    if (isOman) {
      this.governorates = toSignal(this.lookupsService.getGovernorates({ id }).pipe(fallbackOnError(undefined)), {
        injector: this.injector,
      });

      if (!this.itemId) {
        this.form.get("membershipCompanyDetails")!.get("governorateId")!.enable();
        this.form.get("membershipCompanyDetails")!.get("stateId")!.enable();
      }
    } else {
      this.form.get("membershipCompanyDetails")!.get("governorateId")!.disable();
      this.form.get("membershipCompanyDetails")!.get("stateId")!.disable();
    }
  }

  getStates(id: number) {
    this.states = toSignal(this.lookupsService.getStates({ id }).pipe(fallbackOnError(undefined)), { injector: this.injector });
  }

  getPhoneCountryCode(countryCode: string | number | boolean) {
    const country = this.countries().find((c) => c.phoneCode === countryCode);

    if (country) {
      const countryPhoneRegex = (country as any).phoneCodeRegex;

      this.form
        .get("membershipCompanyDetails")
        ?.get("phone")
        ?.setValidators([Validators.required, customValidations.withCustomMobileNumberRegex(countryPhoneRegex)]);

      this.form.get("membershipCompanyDetails")?.get("phone")?.markAllAsTouched();
      this.form.get("membershipCompanyDetails")?.get("phone")?.updateValueAndValidity();
    }
  }
}
